import gql from 'graphql-tag'
import { ReelCard_reel } from './ReelCard.fragments'

const path =
  '/reels' +
  '?filter[project]={args.projectId}' +
  '&filter[user]={args.userId}' +
  '&page[size]=50' +
  '&sort=-update_dt' +
  '&fields[reels]=id,name,published_to_presentation_fl,thumbnail_url,clip_count,update_dt'

const VI_CURRENT_USER_REELS_QUERY = gql`
  query VICurrentUserReelsQuery($projectId: String!, $userId: String!) {
    reels(projectId: $projectId, userId: $userId)
      @jsonapi(path: "${path}", includeJsonapi: true) {
      graphql {
        ... on VIReels {
          id

          ...ReelCard_reel
        }
      }
      jsonapi {
        links {
          next
        }
      }
    }
  }

  ${ReelCard_reel}
`

export const VI_DYNAMIC_CURRENT_USER_REELS_QUERY = gql`
  query VICurrentUserReelsQuery($path: String!) {
    reels(path: $path) @jsonapi(path: "{args.path}", includeJsonapi: true) {
      graphql {
        ... on VIReels {
          id

          ...ReelCard_reel
        }
      }
      jsonapi {
        links {
          next
        }
      }
    }
  }

  ${ReelCard_reel}
`

export default VI_CURRENT_USER_REELS_QUERY
